import { IonContent, IonPage } from "@ionic/react";
import React, { useState } from "react";
import "./index.css";
import Axios from "axios";

import config from "../../config.json";

import { Questions } from "./Questions";
import { Email } from "./Email";
import { Resultado } from "./Resultado";

const Test: React.FC = () => {
  const [data, setData] = useState<string[] | undefined>();
  const [eneatype, setEneatype] = useState<number | undefined>();

  let bodyElement: any;
  if (data) {
    if (eneatype) {
      bodyElement = <Resultado eneatype={eneatype}></Resultado>;
    } else {
      bodyElement = (
        <Email
          onFinish={(email) => {
            Axios.put(config.api.cuestionario, {
              respuestas: data,
              email: email,
            }).then((x) => {
              setEneatype(x.data.eneatype);
            });
          }}
        ></Email>
      );
    }
  } else {
    bodyElement = (
      <Questions
        onFinish={(result) => {
          setData(result);
        }}
      ></Questions>
    );
  }
  return (
    <IonPage className="Test">
      <IonContent fullscreen>{bodyElement}</IonContent>
    </IonPage>
  );
};

export default Test;
